import { useToast } from '@/components/Toasts/hooks/useToast.js';
import { type Message } from '@/components/Toasts/types.js';
import { useCallback } from 'react';

type useCopyToClipboardOptions = {
  errorToast?: Message;
  hideToast?: boolean;
  successToast?: Message;
};

type useCopyToClipboard = () => (
  textToCopy: string,
  options?: useCopyToClipboardOptions,
) => Promise<void>;

const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    throw new Error(`Failed to copy text: ${error}`);
  }
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const useCopyToClipboard: useCopyToClipboard = () => {
  const toast = useToast();
  const copyUrl = useCallback(
    async (
      textToCopy: string,
      {
        errorToast = 'Failed to copy the link. Please try again.',
        hideToast = false,
        successToast = 'Portfolio link copied',
      }: useCopyToClipboardOptions = {},
    ) => {
      try {
        await copyToClipboard(textToCopy);
        if (hideToast) return;
        toast.success(successToast);
      } catch {
        toast.error(errorToast);
      }
    },
    [toast],
  );

  return copyUrl;
};
